import { css, mediaQueries } from '@eti/styles';
import { m as motion } from 'framer-motion';
import { useEffect, useRef } from 'react';
import { getMealPreselectedTravelerChoices, sortTravelers } from '../utils/smallMealUtil';
import { getSellSpecification } from '../utils/mealUtil';
import { useMealCardSelection, useSmallMealPrice } from '../common/hooks';
import MealTravelerSelection from './MealTravelerSelection';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  grid-area: 5 / 1 / 6 / 3;
  overflow: hidden;

  @media ${mediaQueries.medium.up} {
    margin-inline-start: auto;
    width: 70%;
  }
`;
const SmallMealContent = _ref => {
  let {
    cardSelection,
    mealPriceRaw,
    order,
    isMultipleTravelers,
    productName,
    smallMealTravelers,
    selectTraveler,
    selectProduct,
    selectAllTravelers,
    updateInitialValues,
    hasAnySelected,
    updateTotalPrice
  } = _ref;
  const hasInitializedDefaultValues = useRef(false);
  const travelerInitialValues = getMealPreselectedTravelerChoices(order.travelers, getSellSpecification(order));
  useEffect(() => {
    if (!hasInitializedDefaultValues.current) {
      updateInitialValues(travelerInitialValues);
      hasInitializedDefaultValues.current = true;
    }
  }, [updateInitialValues, travelerInitialValues]);
  const sortedTravelers = isMultipleTravelers ? sortTravelers(smallMealTravelers) : smallMealTravelers;
  const sortedTravelersWithMeals = sortedTravelers.filter(traveler => traveler.mealPreferences.length > 0);
  useSmallMealPrice(updateTotalPrice, mealPriceRaw);
  const [isOpen] = useMealCardSelection(hasAnySelected, cardSelection, selectProduct, selectAllTravelers, sortedTravelersWithMeals);
  return /*#__PURE__*/_jsx(motion.div, {
    animate: {
      display: isOpen ? 'block' : 'none',
      height: isOpen ? 'auto' : 0,
      overflow: isOpen ? 'visible' : 'hidden'
    },
    className: wrapperStyles,
    "data-testid": "meal-content",
    initial: "false",
    onAnimationComplete: () => {
      selectAllTravelers(smallMealTravelers, cardSelection !== null && cardSelection !== void 0 ? cardSelection : false);
    },
    transition: {
      type: 'tween'
    },
    children: sortedTravelersWithMeals.map((traveler, index) => /*#__PURE__*/_jsx(MealTravelerSelection, {
      productName: productName,
      selectTraveler: selectTraveler,
      traveler: traveler
    }, index))
  });
};
export default SmallMealContent;
//# sourceMappingURL=SmallMealContent.js.map